import type { CartItem } from '@src/domains/cart';
import type { DetailedSaleItem } from '@src/domains/orders';

import { isCartLineItem, type SummaryLineItem } from './summaryLineItem';

export type SummaryAdditionalDisplayRow = {
  key: string;
  quantity: number;
  name: string;
  totalCents: number;
};

export const buildCartAdditionalRows = (item: CartItem): SummaryAdditionalDisplayRow[] =>
  (item.additionals ?? []).map((cartAdditional) => ({
    key: cartAdditional.additional.id,
    quantity: cartAdditional.quantity,
    name: cartAdditional.additional.title,
    totalCents: cartAdditional.amountCurrencyInfo.amountCents,
  }));

export const buildSaleAdditionalRows = (item: DetailedSaleItem): SummaryAdditionalDisplayRow[] =>
  (item.additionals ?? []).map((saleAdditional) => ({
    key: saleAdditional.id,
    quantity: saleAdditional.unitQuantity,
    name: saleAdditional.additional.title,
    totalCents: saleAdditional.priceCurrencyInfo.amountCents,
  }));

export const getSummaryAdditionalRows = (item: SummaryLineItem): SummaryAdditionalDisplayRow[] =>
  isCartLineItem(item) ? buildCartAdditionalRows(item) : buildSaleAdditionalRows(item);
